var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTajMahal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V2.56371C9.85464 3.66708 7 6.20482 7 8.5C7 8.95131 7.04942 9.36786 7.14262 9.75H16.8574C16.9506 9.36786 17 8.95131 17 8.5C17 6.20482 14.1454 3.66708 12.75 2.56371V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 11.7348 7.05163 11.4816 7.14538 11.25H16.8546C16.9484 11.4816 17 11.7348 17 12V21.25H18V12C18 11.9153 18.0053 11.8319 18.0155 11.75H21.9845C21.9947 11.8319 22 11.9153 22 12V21.25C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25V12C2 11.9153 2.00526 11.8319 2.01547 11.75H5.98453C5.99474 11.8319 6 11.9153 6 12V21.25H7V12ZM15 21.25V15.5352C15 15.2008 14.8329 14.8886 14.5547 14.7031L12.5547 13.3698C12.2188 13.1459 11.7812 13.1459 11.4453 13.3698L9.4453 14.7031C9.1671 14.8886 9 15.2008 9 15.5352V21.25H15ZM5 14C5 13.4477 4.55228 13 4 13C3.44772 13 3 13.4477 3 14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14ZM20 15C20.5523 15 21 14.5523 21 14C21 13.4477 20.5523 13 20 13C19.4477 13 19 13.4477 19 14C19 14.5523 19.4477 15 20 15Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9855 10.25C5.99507 10.1554 6 10.057 6 9.95455C6 8.57383 4 7 4 7C4 7 2 8.57383 2 9.95455C2 10.057 2.00493 10.1554 2.0145 10.25H5.9855Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.95455C22 10.057 21.9951 10.1554 21.9855 10.25H18.0145C18.0049 10.1554 18 10.057 18 9.95455C18 8.57383 20 7 20 7C20 7 22 8.57383 22 9.95455Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTajMahal);
export default __webpack_public_path__ + "static/media/taj-mahal.0bc1abda348af208e0c08cad6c1149cc.svg";
export { ForwardRef as ReactComponent };